import { ApiService } from '@dirootie-core/api-types';
import { Course } from './Course';

export class CourseApiService extends ApiService<Course, Course> {}
